module.exports = __webpack_public_path__ + "img/ltkaustralia-1x.b5c6ec2.jpg";